<template>
  <div class="home-pannel concented" style="height: 100%;">
    <div class="home-pannel-title titleed">
      <span>付款计划统计</span>
      <div class="titleed-sele" style="margin-left: 10px;">
        <queryView @select="timeSelect" />
        <!-- <a-select :default-value="'本月'" size="small" style="width: 80px" @change="change">
          <a-select-option v-for="(item, index) in monthList" :key="index">
            {{item}}
          </a-select-option>
        </a-select> -->
      </div>
    </div>
    <div style="height: 86%;">
      <a-row style="height: 100%;">
        <a-col :span="12" class="echarts" style="height: 100%;">
          <div ref="paymentPlanChart" style="width: 96%;height: 96%;"/>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import queryView from './queryView.vue'
export default {
  components: {queryView},
  data () {
    return {
      paymentPlanChart: null,
      countsed: 0,
      monthList: ['本月', '上月', '一季度', '二季度', '三季度', '四季度', '当前年', '上年'],
      timedmsg: (new Date()).getMonth() + 1
    }
  },
  activated () {
    this.initEcharts()
  },
  mounted () {
    this.initEcharts()
  },
  methods: {
    initEcharts () {
      setTimeout(() => {
        this.paymentPlanChart = this.$echarts.init(this.$refs.paymentPlanChart)
        this.initData(this.timedmsg)
      }, 200)
    },
    initData (time) {
      this.countsed = 0
      this.$get('payPlan/count', {timeCondition: time}).then(res => {
        let arr = []
        res.data.data.forEach(item => {
          this.countsed += Number(item.sum)
          if (item.type === 0) {
            arr.push({
              name: '未付款',
              value: item.sum,
              value1: item.count,
              itemStyle: {color: '#f9ae3d'}
            })
          } else {
            arr.push({
              name: '已付款',
              value: item.sum,
              value1: item.count,
              itemStyle: {color: '#3c9cff'}
            })
          }
        })
        this.createpaymentPlanChart(arr)
      })
    },
    change (e) {
      this.initData(this.monthList[e])
    },
    timeSelect (timeVal) {
      this.initData(timeVal)
    },
    createpaymentPlanChart (arr) {
      let that = this
      let option = {
        backgroundColor: 'white',
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: function (value) {
            return `金额 : ${value.data.value}元 <br/> 数量 : ${value.data.value1}笔`
          },
          backgroundColor: 'rgba(1, 13, 19, 0.5)',
          borderWidth: 0,
          textStyle: {
            color: 'rgba(212, 232, 254, 1)'
            // fontSize: fontChart(0.24),
          }
        },
        legend: {
          // orient: 'vertical',
          left: 'center',
          bottom: '6%',
          itemWidth: 15,
          itemHeight: 10,
          itemGap: 25,
          borderRadius: 4,
          textStyle: {
            color: '#000',
            fontFamily: 'Alibaba PuHuiTi',
            fontSize: 14,
            fontWeight: 400
          }
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '50%',
            center: ['50%', '50%'],
            data: arr,
            label: {
              normal: {
                formatter: function (parms) {
                  var str = ((parms.data.value * 100) / (that.countsed * 100) * 100).toFixed(2) + '%'
                  if (isNaN(((parms.data.value * 100) / (that.countsed * 100)).toFixed(4))) {
                    if (parms.data.name === '未付款') {
                      return '{green|' + parms.data.name + '：}\n{d|' + '0%}'
                    } else {
                      return '{green|' + parms.data.name + '：}\n{e|' + '0%}'
                    }
                  } else {
                    if (parms.data.name === '未付款') {
                      return '{green|' + parms.data.name + '：}\n{d|' + str + '}'
                    } else {
                      return '{green|' + parms.data.name + '：}\n{e|' + str + '}'
                    }
                  }
                },
                textStyle: {
                  fontSize: '16px',
                  textAlign: 'center'
                },
                rich: {
                  c: {
                    color: 'red',
                    fontSize: 20,
                    fontWeight: 'bold',
                    lineHeight: 5
                  },
                  b: {
                    fontSize: 15,
                    height: 40
                  },
                  d: {
                    color: '#f9ae3d',
                    fontSize: '20px',
                    fontWeight: 900
                  },
                  e: {
                    fontSize: '20px',
                    fontWeight: 900,
                    color: '#3c9cff'
                  }
                }
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      this.paymentPlanChart.setOption(option, true)
    }
  }
}
</script>

<style lang="less" scoped>
  .titleed{
    display: flex;
    &-sele{
      font-weight: 500;
    }
  }
  .echarts {
    width: 100%;
    display: flex; /*设置为Flex容器*/
    justify-content: center; /*水平居中对齐*/
  }
    .panel {
      padding-bottom: 0.6rem;
      background-color: #fff;
      border: 1px solid transparent;
      border-radius: 10px;

      .panel-title {
        width: 100%;
        border-bottom: solid 1px #e9e9e9;
        line-height: 50px;
        padding-left: 15px;
        position: relative;

        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 30px;
          background-color: #0079fe;
          position: absolute;
          left: 0;
          top: 10px;
          border-radius: 4px;
        }

        span {
          &:first-child {
            font-size: 18px !important;
            font-weight: 400;
          }
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/homeComponents/paymentPlanChart.vue